
import { defineComponent } from "vue";
import { PropType } from "vue";
import meetlookup from "../MeetLookup";
import { RelayEvent } from "@/types/Club";

export default defineComponent({
  name: "RelayTable",
  mixins: [meetlookup],
  props: {
    relayEvents: Array as PropType<Array<RelayEvent>>,
    clubName: String,
  },
});
